import { render, staticRenderFns } from "./Product-Tab-PharmacyInfo.vue?vue&type=template&id=27f8949c&scoped=true"
import script from "./Product-Tab-PharmacyInfo.vue?vue&type=script&lang=js"
export * from "./Product-Tab-PharmacyInfo.vue?vue&type=script&lang=js"
import style0 from "./Product-Tab-PharmacyInfo.vue?vue&type=style&index=0&id=27f8949c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f8949c",
  null
  
)

export default component.exports